import * as fromTeacherSearchResults from '../actions/teacher-searchresults.action';
import * as fromModels from '../../models';
import { HttpHeaders } from '@angular/common/http';

export interface SearchResultsState {
    searchResults: fromModels.TeacherSearchResultsItem[];
    searchCriteria: fromModels.TeacherSearchCriteria;
    pagingSorting: fromModels.TeacherPagingSorting;
    errors: any;	//	TODO: formalize error handling
    loading: boolean;
    loaded: boolean;
}

export const initialState: SearchResultsState = {
    loading: false,
    loaded: false,
    searchResults: null,
    errors: null,
    searchCriteria: {
        id: null,
        name: null,
        districtName: null,
        county: null,
        state: null,
        zip: null,
        radius: null,
        phone: null,
        isActive: null,
        PageNumber: null,
        PageSize: null,
        SortBy: null,
        SortDir: null,
        schoolId: null,
        districtId: null,
    },
    pagingSorting: {
        totalCount: null,
        pageSize: null,
        currentPage: null,
        totalPages: null,
        sortBy: null,
        sortDir: null
    }
};

export function reducer(state = initialState, action: fromTeacherSearchResults.TeacherSearchResultsActions): SearchResultsState {
    switch (action.type) {
        case fromTeacherSearchResults.TeacherSearchResultsActionTypes.ProcessQueryString: {
            console.log('ProcessQueryString');
            console.log(action.payload);

            return {
                ...state,
                loaded: false,
                loading: false,
                errors: null
            };
        }

        case fromTeacherSearchResults.TeacherSearchResultsActionTypes.LoadTeacherSearchResults: {
            console.log('LoadTeacherSearchResults');
            console.log(action.payload);
			return {
                ...state,
                loaded: false,
                loading: true,
                errors: null,
                // Anytime we request search results, let's update the state to include that
                // most recent criteria that was just passed.
                searchCriteria: action.payload
			};
		}

        case fromTeacherSearchResults.TeacherSearchResultsActionTypes.LoadTeacherSearchResultsSuccess: {
            const searchResults = action.payload;
            const headers = action.httpHeaders;

			return {
                ...updateTeacherSearchResultsState(state, searchResults, headers),
				loaded: true,
                loading: false
			};
		}

        case fromTeacherSearchResults.TeacherSearchResultsActionTypes.LoadTeacherSearchResultsFailure: {
			console.log('reducer:', action);

			return {
				...state,
				loaded: false,
				loading: false,
                errors: action.payload
			};
        }
	}

	return state;
}

function updateTeacherSearchResultsState(state: SearchResultsState, searchResults: fromModels.TeacherSearchResultsItem[], headers: HttpHeaders) {
    let pagingSorting: fromModels.TeacherPagingSorting;

    // Grab special header we use for paging
    const pagingHeader: string = headers.get('X-Pagination');
    const pagingObject: object = JSON.parse(pagingHeader);

    // Populate paging information from http headers
    pagingSorting = {
        totalCount: pagingObject['totalCount'],
        pageSize: pagingObject['pageSize'],
        currentPage: pagingObject['currentPage'],
        totalPages: pagingObject['totalPages'],
        sortBy: pagingObject['sortBy'],
        sortDir: pagingObject['sortDir']
    };

	return {
		...state,
        searchResults,
        pagingSorting
	};
}

export const getTeacherSearchResults = (state: SearchResultsState) => state.searchResults;
export const getDetailsStateLoading = (state: SearchResultsState) => state.loading;
export const getDetailsStateLoaded = (state: SearchResultsState) => state.loaded;
export const getDetailsStateErrors = (state: SearchResultsState) => state.errors;
